import React from 'react';
import { motion } from 'framer-motion';
export function HeroSection() {
  const scrollToPricing = (e: React.MouseEvent) => {
    e.preventDefault();
    document.getElementById('comprar')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <section id="hero" className="pt-24 pb-8 md:pt-32 md:pb-12 bg-emerald-50 overflow-hidden" data-id="element-60">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 relative text-center" data-id="element-61">
        <motion.h1 initial={{
        opacity: 0,
        y: -20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.5
      }} className="text-4xl md:text-5xl lg:text-6xl font-extrabold text-gray-900 leading-tight mb-8" data-id="element-62">
          Sistema PRO: <br data-id="element-63" />
          <span className="text-emerald-600" data-id="element-64">Pediatría</span>
        </motion.h1>

        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.6,
        delay: 0.15
      }} className="relative cursor-pointer group mb-6 max-w-xl mx-auto" onClick={scrollToPricing} data-id="element-65">
          <div className="absolute inset-0 bg-emerald-200 rounded-full blur-3xl opacity-30 group-hover:opacity-50 transition-opacity duration-500" data-id="element-66"></div>
          <img src="https://cdn.magicpatterns.com/uploads/wYgxN6y3qFwPFdMk5Jzy9G/Firefly_Corregi_los_colores_par_que_todo_sea_en_degrade_de_esos_verdes_calmos,_y_que_los_dibu_972492-Photoroom.png" alt="Sistema PRO: Pediatría - Libro, tablet y módulos del sistema" className="relative z-10 w-full max-w-md mx-auto drop-shadow-2xl transform group-hover:scale-105 transition-transform duration-500" data-id="element-67" />
        </motion.div>

        <motion.p initial={{
        opacity: 0,
        y: 10
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.5,
        delay: 0.3
      }} className="text-lg md:text-xl text-gray-600 mb-6 max-w-2xl mx-auto" data-id="element-68">
          Recursos avanzados y protocolos clínicos para profesionales que
          acompañan el desarrollo y la salud infantil.
        </motion.p>

        <motion.div initial={{
        opacity: 0,
        y: 10
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.5,
        delay: 0.4
      }} data-id="element-69">
          <button onClick={scrollToPricing} className="bg-emerald-600 hover:bg-emerald-700 text-white text-lg font-bold py-4 px-10 rounded-full shadow-lg hover:shadow-xl transition-all transform hover:-translate-y-1" data-id="element-70">
            👉 Acceder al Sistema PRO ahora
          </button>
        </motion.div>
      </div>
    </section>;
}